<template>
  <v-app>
    <div v-if="$loading" class="loading">
      <v-progress-circular indeterminate size="100" width="10" />
    </div>
    <!-- v-main: ページコンテンツとレイアウト要素を連動させるためのキーコンポーネント -->
    <v-main class="padding-top-0">
      <!-- vue-router(router-view) を使用する場合は、v-main の中にビューを配置する -->
      <transition mode="out-in" v-if="transitionType === 'fade'" name="fade">
        <router-view />
      </transition>
      <transition mode="out-in" v-else-if="transitionType === 'slideLeft'" name="slide-left">
        <router-view />
      </transition>
      <transition mode="out-in" v-else-if="transitionType === 'slideRight'" name="slide-right">
        <router-view />
      </transition>
      <transition v-else name="">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import NativeApi from './api/nativeApi';
import NativeCallback from './api/nativeCallback';
// import axios from "axios";
let browserBack = false;

/**
 * @module App
 */
export default {
  name: 'App',
  head: {
    meta: [
      // アドレスバーの色を指定
      { name: 'theme-color', content: '#1d50a2' }, // Android
      { name: 'apple-mobile-web-app-status-bar-style', content: '#1d50a2' }, // iOS
    ],
  },
  data: () => ({
    transitionType: '',
  }),
  components: {},
  async created() {
    window.addEventListener('popstate', function () {
      browserBack = true;
    });
  },
  beforeMount() {
    // Native部との通信を行うCallback関数をwindowオブジェクトに登録
    // IF10_アプリNative部エラー通知
    window.onNativeError = (error) => {
      const nativeError = NativeCallback.onNativeError(error);
      this.$store.commit('appInfo/setNativeError', nativeError);
      /* Vuexに置かれたerrorCodeの監視は、各コンポーネントで
        -----
        computed: {
          foo() {
            return this.$store.getters["appInfo/getNativeError"]
          },
        },
        watch: {
          foo (newVal, oldVal) {
            1. newValに応じた処理
            const intError = {errorCode: ""}
            2. this.$store.commit("appInfo/setNativeError", initError);
          }
        }
        -----
        と書く。
      */
    };
    // IF11_ライフサイクルイベント通知
    window.onAppLifeCycleStateChanged = (error, state) => {
      const appState = NativeCallback.onAppLifeCycleStateChanged(error, state);
      this.$store.commit('appInfo/setLifeCycleState', appState);

      if (this.$isIosApp) {
        NativeApi.requestNativeAppInfo();
      }
      // 各コンポーネントでの状態の監視はIF10と同様の記述が必要
    };

    window.onDeviceTokenUpdated = (errorCode) => {
      const nativeError = NativeCallback.onDeviceTokenUpdated(errorCode);
      this.$store.commit('appInfo/setDeviceTokenError', nativeError);
    };
  },
  // mountedはページの読み込みが開始したときに、コンポーネントやDOMを
  // 読み込むよりも早い段階で実行される処理
  mounted: function () {
    // 1. タブタイトルを変更
    const routeInstance = this.$route;
    this.createTitleDesc(routeInstance);

    // 2. 利用端末の登録
    if (this.$store.getters['appInfo/getAppUserEnv'].isMobile === '') {
      // getAppUserEnv初期化時に一度だけ実行
      const agent = window.navigator.userAgent;
      //#29098
      const isMobile =
        agent.match(/iPhone|iPad/) || //iPad も含める
        (agent.match(/Macintosh/) &&
          window.ontouchstart !== undefined &&
          0 < navigator.maxTouchPoints) || // iPhone/iPadの場合はPCモードで開いている時があるので、タッチ可能なマックも含める
        agent.match(/Android/); // Android タブレットも含みたいので、.+Mobileを削除

      const isMobileApp = agent.indexOf('ALSOK_NHSApp') !== -1 ? true : false;
      const isAndroidApp = agent.indexOf('ALSOK_NHSApp/Android') !== -1 ? true : false;
      const isIosApp = agent.indexOf('ALSOK_NHSApp/iOS') !== -1 ? true : false;
      if (isMobileApp) {
        this.$store.commit('appInfo/setDeviceOs', isAndroidApp ? 1 : 2); // 1: Android, 2: iSO
      }
      const appUserEnv = {
        isMobile: isMobile,
        isPc: !isMobile && !isMobileApp,
        isBrowser: !isMobileApp,
        isMobileWeb: isMobile && !isMobileApp,
        isMobileApp: isMobileApp,
        isAndroidApp: isAndroidApp,
        isIosApp: isIosApp,
      };
      this.$store.commit('appInfo/setAppUserEnv', appUserEnv);

      // 3. サポート外のブラウザの場合、sorry画面に遷移
      if (!isMobileApp) {
        // モバイルアプリではない場合＝ブラウザの場合
        const isChrome = agent.indexOf('Chrome') !== -1;
        const isSafari = agent.indexOf('Safari') !== -1;
        const isEdge = agent.indexOf('Edge') !== -1;
        if (!(isChrome || isSafari || isEdge)) {
          this.$store.commit('setSorryType', { sorryType: 1 });
          this.$router.replace({
            path: '/sorry',
            //query: { hoge_token: data }
          });
        }
      }
    }

    // 4. 利用端末に応じてフォントを変更
    if (this.$isAndroidApp) {
      document.getElementById('app').style.fontFamily = "'Noto Sans CJK','sans-serif'";
    } else if (this.$isIosApp) {
      document.getElementById('app').style.fontFamily = "'ヒラギノ角ゴシック','sans-serif'";
    }

    // n. 追加の処理
  },
  computed: {
    deviceTokenError() {
      return this.$store.getters['appInfo/getDeviceTokenError'].errorCode;
    },
  },

  watch: {
    $route(routeInstance, from) {
      if (this.$browserBack) this.$browserBack = false;
      if ((browserBack && this.$goBack) || this.$store.state.backButtonFlag) {
        // 戻るボタン
        this.transitionType = 'slideLeft';
      } else if (!browserBack && !this.$goBack && from.name != null) {
        // 進むボタン
        if (from.name !== 'Login') {
          // ログインボタン以外押下
          this.transitionType = 'slideRight';
        } else {
          // ログインボタン押下
          if (routeInstance.name === 'OneTimePassword' || routeInstance.name === 'Top') {
            // 2段階認証またはトップ画面に遷移
            this.transitionType = 'fade';
          } else {
            // 2段階認証またはトップ画面以外に遷移
            this.transitionType = 'slideRight';
          }
        }
      } else {
        // ブラウザバック
        this.transitionType = '';
        if (browserBack) this.$browserBack = true;
      }

      this.$store.state.backButtonFlag = false;
      browserBack = false;
      this.createTitleDesc(routeInstance);
    },

    async deviceTokenError(newVal) {
      if (!newVal) {
        return;
      }
      // 電話アプリ起動失敗時
      await this.$errorDialog(this.$vuetify.lang.t('$vuetify.tokenUpdateError.content'));

      this.$store.commit('appInfo/setDeviceTokenError', { errorCode: '' });
      await this.logout();
    },
  },
  methods: {
    createTitleDesc: function (routeInstance) {
      // routeInstanceとは$routeを代入した変数
      if (routeInstance.meta.title) {
        var setTitle = routeInstance.meta.title + ' | HOME ALSOK';
        document.title = setTitle;
      } else {
        document.title = 'Alsok';
      }
    },
    async logout() {
      await this.$_APP_CU0202();
    },
  },
};
</script>
